/**
 * Inicjalizacja i18next dla całej aplikacji (panel admina + portal klienta).
 *
 * - Wykrywanie języka: najpierw localStorage ('lang'), potem język przeglądarki
 *   (navigator). Brak dopasowania → angielski (fallbackLng).
 * - Wymuszenie języka: <LanguageSwitcher> wywołuje i18n.changeLanguage(code),
 *   wybór zapisywany w localStorage.
 * - Brakujące klucze w danym języku → fallback na en (returnEmptyString=false).
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources, SUPPORTED_LANGUAGES } from './translations';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    // 'de-AT' / 'pt-BR' itp. → bazowy kod języka ('de', 'pt')
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
export { LANGUAGE_NAMES, LANGUAGE_FLAGS, SUPPORTED_LANGUAGES } from './translations';
/** Języki z dostępnym tłumaczeniem (do menu wyboru). Reszta wspieranych kodów spada na en. */
export const AVAILABLE_LANGUAGES = Object.keys(resources);
